import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { APPSETTING } from '../../main';

const ReveenAppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const userDataString = localStorage.getItem(APPSETTING.appname + "user");
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const useremail = userData?.user?.email || "User";

  const handleLogout = () => {
    localStorage.removeItem(APPSETTING.appname + "user");
    navigate('/login');
  };

  const navitems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Ops Users", path: "/master" },
    { label: "Products", path: "/product" },
    { label: "Locations", path: "/location" },
    { label: "Customers", path: "/customer" },
    { label: "Deliveries", path: "/admindelivery" },
    { label: "Delivery Partners", path: "/deliverypartner" },
    { label: "Payments", path: "/adminpayment" },
    { label: "Subscriptions", path: "/adminsubscription" },
    { label: "Message Log", path: "/adminmessagelog" },
    { label: "Delivery Reports", path: "/admindeliveryreport" }
  ];

  return (
    <div className="dash-wrapper" style={{ display: 'flex', minHeight: '100vh' }}>
      <aside className="dash-sidebar">
        <div className="dash-sidebar-header">
          <h3>VEENWATER</h3>
          <span>Operations Core Control v1.1</span>
        </div>

        <nav className="dash-nav">
          {navitems.map((item) => (
            <div
              key={item.path}
              className={location.pathname === item.path ? "nav-item active" : "nav-item"}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </div>
          ))}
        </nav>
      </aside>

      <div className="dash-main" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <header className="dash-header" style={{ padding: '1rem', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ position: 'relative' }}>
            <div 
              style={{ cursor: 'pointer', fontWeight: 'bold' }} 
              onClick={() => setShowProfileMenu(!showProfileMenu)}
            >
              {useremail}
            </div>
            {showProfileMenu && (
              <div style={{ position: 'absolute', right: 0, top: '2rem', background: '#fff', border: '1px solid #ccc', padding: '0.5rem', borderRadius: '4px', zIndex: 10 }}>
                <button onClick={handleLogout} style={{ cursor: 'pointer' }}>Sign out</button>
              </div>
            )}
          </div>
        </header>

        <div className="content-area" style={{ padding: '1.5rem', flex: 1 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReveenAppLayout;